<template>
    <footer class="p-4 flex flex-center">
        <ul
            class="flex max-sm:w-[355px] flex-wrap max-[370px]:gap-[10px] gap-[15px]"
        >
            <li
                v-for="(button, index) in buttons"
                :key="index"
                class="footer-list-element flex items-center"
            >
                <BasicNuxtLink
                    :id="button.id"
                    :href="button.href"
                    target="_blank"
                    color="info"
                    is-inside-text
                    size="sm"
                    uppercase
                >
                    <span
                        class="text-center max-[370px]:text-[9px] block font-medium leading-[18px] w-max text-[11px]"
                    >
                        {{ button.text }}
                    </span>
                </BasicNuxtLink>
            </li>
        </ul>
    </footer>
</template>

<script setup lang="ts">
import BasicNuxtLink from '@atoms/BasicNuxtLink.vue';

import { useLegalUrl } from '@composables/useLegalUrl';
import { useI18n } from '#imports';

const { t } = useI18n();

const { links } = useLegalUrl();

const buttons = computed(() => [
    {
        text: t('atp.components.app_footer.text_us'),
        href: 'mailto:attendeespace@clickmeeting.com',
        id: 'text-us-button',
    },
    {
        text: t('atp.components.app_footer.status'),
        href: 'https://status.clickmeeting.com/',
        id: 'status-button',
    },
    {
        text: t('atp.components.app_footer.privacy_policy'),
        href: links.value.privacyPolicy,
        id: 'privacy-policy-button',
    },
    {
        text: t('atp.components.app_footer.tos'),
        href: links.value.tos,
        id: 'tos-button',
    },
]);
</script>

<style scoped>
.footer-list-element::after:not(:last-child) {
    @apply content-[''] block w-[3px] max-[370px]:ml-[10px] ml-[15px] h-[3px] mt-[-2px] border border-input bg-input rounded-full;
}
</style>
